const About = [
    {Header:"豐富開發經驗",BgColor:"#F5FCFC",Content:["豐富的不同業別及不同應用系統開發經驗，公司開發成員從 2012 年開始，即在為不同行業，委外開發不同應用系統。對於不同應用系統，成員具備充份應用知識。"]},
    {Header:"專業工作知識",BgColor:"#E7F4FF",Content:["團隊成員熟悉軟體工程，對於專案流程控管與管理具備豐富經驗，配合內部管理系統工具，有效地管理專案文件，程式碼，及 交付佈署。","我們提供的軟體服務皆是以客戶為核心，專注在提供最有效以及能在最短的時間內快速整合上線的解決方案，期望為客戶與使用者帶來更多的便利、價值與競爭力．"]},
    {Header:"團隊組成",BgColor:"#F8F9F9",Content:["我們的團隊包含專案經理、軟體開發工程師、Mobile/APP開發人員、UI/UX設計師及系統分析及設計專家，團隊價值多元開放、樂於分享，與客戶一起達成目標。"]}
];

export default About;